import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const ForgottenPasswordForm = ({ error, handleSubmit, pristine, submitting, t }) => {

	return (
		<form onSubmit={handleSubmit} className='form-login'>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='username' component={Input} type='text' placeholder={t('FO_Login_Email')} icon='fa fa-envelope' validate={[validators.required, validators.email]} className='form-control redux-field' />
			<div className='form-actions'>
				<Button type='submit' disabled={pristine || submitting} className='btn btn-primary pull-right btn-auth'>
					{t('FO_ForgottenPassword_Submit')} <i className='fa fa-arrow-circle-right' />
				</Button>
				<Link to='/login' className='btn btn-info btn-auth'>{t('Common_Back')}</Link>
			</div>
		</form>
	);
};

ForgottenPasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'forgottenPassword' })(withTranslation()(ForgottenPasswordForm));